import { types } from '../types/types';

export const authReducer = (state = {}, action) => {
    switch (action.type) {
        case types.login:
            return {
                data: action.payload.data.data,
                token: action.payload.data.token
            }
        case types.logout:
            return {}

        default:
            return state;
    }
}